import { render } from "./DataExport.vue?vue&type=template&id=1001bfb3&scoped=true"
import script from "./DataExport.vue?vue&type=script&lang=js"
export * from "./DataExport.vue?vue&type=script&lang=js"

import "./DataExport.vue?vue&type=style&index=0&id=1001bfb3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1001bfb3"]])

export default __exports__